export const OLD_COURSE_EXPRESS_MESSAGE =
  "This export id is of an old course, republish to work with Express";

async function fileExists(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, { method: "HEAD" });
    return res.ok;
  } catch {
    return false;
  }
}

export async function isOldCourseForExpress(packagePath: string): Promise<boolean> {
  if (!packagePath) {
    return false;
  }
  const base = packagePath.replace(/\/$/, "");
  const [hasAnnotationsJs, hasAnnotationsJson] = await Promise.all([
    fileExists(`${base}/annotations.js`),
    fileExists(`${base}/annotations.json`),
  ]);
  return hasAnnotationsJs && !hasAnnotationsJson;
}
